/**
 * Chip checked-state fallback for browsers without `:has()` support
 * (Safari < 15.4, Firefox < 121).
 *
 * Listens for change events on chip radios and toggles `.is-checked` on
 * the parent label. The `:has()` selector in `_contact.scss` still wins
 * on modern browsers; this is purely additive.
 */
export function initChipFallback() {
  // Feature-detect — bail out where :has() is supported. CSS.supports
  // returns false in browsers that don't recognize the selector.
  const supportsHas =
    typeof CSS !== 'undefined' &&
    CSS.supports &&
    CSS.supports('selector(:has(*))');
  if (supportsHas) return;

  document.querySelectorAll('.chip').forEach((chip) => {
    const input = chip.querySelector('input[type="radio"], input[type="checkbox"]');
    if (!input) return;

    const sync = () => chip.classList.toggle('is-checked', input.checked);

    if (input.type === 'radio' && input.name) {
      // Radios in the same group: when one fires change, others in the
      // group lose checked state silently (no event). Re-sync siblings.
      input.addEventListener('change', () => {
        document
          .querySelectorAll(`input[type="radio"][name="${CSS.escape(input.name)}"]`)
          .forEach((r) => {
            const parent = r.closest('.chip');
            if (parent) parent.classList.toggle('is-checked', r.checked);
          });
      });
    } else {
      input.addEventListener('change', sync);
    }
    sync();
  });
}
